(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSlick() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
      setTimeout(initSlick, 200);
      return;
    }

    jQuery('.review-slider').not('.slick-initialized').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
     autoplay: true,
      speed: 3000,
      arrows: true,
      dots: false,
      infinite: true,
      pauseOnHover: false,
      adaptiveHeight: true,
      prevArrow: $('.custom-prev-2'),
      nextArrow: $('.custom-next-2'),
      responsive: [
        { 
            breakpoint: 992, 
            settings: {
                 slidesToShow: 2 
                }
             },
       { 
            breakpoint: 768, 
            settings: {
                arrows: false,
                dots: true,
                 slidesToShow: 1
                }
             },
      ]
    });
  }

  document.addEventListener('shopify:section:load', initSlick);
  document.addEventListener('DOMContentLoaded', initSlick);
})();

  } catch(e) { console.error(e); }
})();
})();
